import React, { createContext } from 'react';
import type { AppState, AppAction } from './types';

interface AppStateContextProps {
    state: AppState;
    dispatch: React.Dispatch<AppAction>;
}

export const AppStateContext = createContext<AppStateContextProps | undefined>(undefined);
